// extracted by mini-css-extract-plugin
module.exports = {"component":"header-module--component--1saav","logo":"header-module--logo--1Kpti","navigation":"header-module--navigation--5jTIS"};